// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-checkbox-group[data-v-3839e72d] {\n  width: 625px;\n}\n.el-checkbox[data-v-3839e72d]:nth-child(5n + 1) {\n  margin-left: 0;\n}\n#convalescenceAdd .el-form-item__label[data-v-3839e72d] {\n  float: none;\n}\n", ""]);
// Exports
module.exports = exports;
